import {
  List,
  Datagrid,
  ReferenceField,
  TextField,
  DateField,
  SearchInput,
  ReferenceInput,
  TextInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const PurchaseList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <ReferenceInput source="userId" reference="users" />,
      <TextInput source="productId" />,
      <TextInput source="platform" />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ReferenceField source="userId" reference="users" />
      <TextField source="productId" />
      <TextField source="platform" />
      <TextField source="receiptKey" />
      <TextField source="orderId" />
      <DateField source="purchasedAt" />
    </Datagrid>
  </List>
)

export const PurchaseShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="userId" reference="users" />
      <TextField source="productId" />
      <TextField source="platform" />
      <TextField source="receiptKey" />
      <TextField source="orderId" />
      <TextField source="rawReceipt" />
      <DateField source="purchasedAt" />
    </SimpleShowLayout>
  </Show>
)
